export default "__VITE_ASSET__CVHjuN8x__"